import { render, staticRenderFns } from "./PageBuilderGridWidget.vue?vue&type=template&id=2865c9d8"
import script from "./PageBuilderGridWidget.vue?vue&type=script&lang=js"
export * from "./PageBuilderGridWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports